
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
 
<!--Header-->
<router-outlet name="header"></router-outlet>

<!--Main Content-->
<router-outlet></router-outlet>

<!--Footer-->
<router-outlet name="footer"></router-outlet>
